/**
 * @file Manages styles for Paragraph atom.
 * @author kkumari
 */
import { css } from 'styled-components';
import breakPoints from '../../../themes/breakpoints';
export default css(["iframe#iframe-example{height:700px;overflow:hidden;@media (max-width:", "){height:900px;}@media (max-width:", "){height:915px;}}"], breakPoints.mobile, breakPoints.mobileSm);